import * as React from "react";
import {Button, ButtonType} from "./Button";

export default function Page404() {
    return <div className={"page-404 section"}>
        <h1>Ooops, that's awkward!</h1>
        <p>The page you are looking for is not here</p>
        <Button classes={["btn-light", "btn-md"]} type={ButtonType.Link} onClick={process.env.PUBLIC_URL}>Go home</Button>
    </div>
}